import { z } from 'zod';

type T = (key: string) => string;

export const createShipmentSchema = (t: T) =>
  z.object({
    priority: z.enum(['normal', 'high', 'urgent'], {
      message: t('priorityRequired')
    }),
    judicial_entity: z.string().max(255).optional().or(z.literal('')),
    location: z.string().max(255).optional().or(z.literal('')),
    branch: z.string().max(255).optional().or(z.literal('')),
    assigned_employee: z.string().max(255).optional().or(z.literal('')),
    box_count: z.number().int().min(1, t('boxCountMin')),
    shipment_date: z.string().optional().or(z.literal('')),
    notes: z.string().max(5000).optional().or(z.literal(''))
  });

export type ShipmentFormValues = z.infer<
  ReturnType<typeof createShipmentSchema>
>;

export const editShipmentSchema = (t: T) =>
  z.object({
    priority: z.enum(['normal', 'high', 'urgent'], {
      message: t('priorityRequired')
    }),
    location: z.string().max(255).optional().or(z.literal('')),
    notes: z.string().max(5000).optional().or(z.literal('')),
    driver_id: z.string(),
    box_ids: z.array(z.string())
  });

export type EditShipmentFormValues = z.infer<
  ReturnType<typeof editShipmentSchema>
>;
